import * as React from 'react'

import type { ChangeAction } from '../../../hooks/useChangesForEmployees'

interface Props {
  dispatch: React.Dispatch<ChangeAction>
}

const Context = React.createContext<React.Dispatch<ChangeAction> | null>(null)

export const DispatchLocalChangeOnEmployeesProvider = ({
  children,
  dispatch,
}: React.PropsWithChildren<Props>) => {
  return <Context.Provider value={dispatch}>{children}</Context.Provider>
}

export const useDispatchLocalChangeOnEmployees = (): React.Dispatch<ChangeAction> => {
  const values = React.useContext(Context)

  if (!values)
    throw new Error(
      'useDispatchLocalChangeOnEmployees must be used within a DispatchLocalChangeOnEmployeesProvider'
    )

  return values
}
